import {ContestCertificateViewModel} from './certificateViewModel';
import {contestCertificatePrintStyles} from './contestCertificatePrintStyles';
import {certificateAssets} from './certificateAssets';

function escapeHtml(value: string) {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

function renderLineHtml(line: ContestCertificateViewModel['lines'][number]) {
  return line.segments
    .map((segment) => {
      const text = escapeHtml(segment.text);

      return segment.bold ? `<strong>${text}</strong>` : text;
    })
    .join('');
}

export function buildContestCertificateHtml(
  viewModel: ContestCertificateViewModel,
) {
  const linesHtml = viewModel.lines
    .map((line) => `<p>${renderLineHtml(line)}</p>`)
    .join('');

  return `<!DOCTYPE html>
  <html lang="pt-BR">
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>${escapeHtml(viewModel.downloadFileName)}</title>
      <style>${contestCertificatePrintStyles}</style>
    </head>
    <body>
      <div class="page-wrapper">
        <section
          class="certificate-sheet"
          style="background-image: url('${escapeHtml(
            viewModel.backgroundImage,
          )}');"
        >
          <div class="certificate-panel">
            <header class="certificate-header">
              <h1 class="certificate-title">${escapeHtml(viewModel.title)}</h1>
              ${
                viewModel.subtitle
                  ? `<p class="certificate-subtitle">${escapeHtml(
                      viewModel.subtitle,
                    )}</p>`
                  : ''
              }
            </header>

            <section class="certificate-body">
              ${linesHtml}
            </section>

            <footer class="certificate-footer ${
              viewModel.medalImage ? '' : 'no-medal'
            }">
              <div class="signature-block">
                <img
                  src="${escapeHtml(certificateAssets.signature)}"
                  alt="Assinatura de Luis Junqueira"
                  class="signature-image"
                />
                <span class="signature-line"></span>
                <span class="signature-text">Luis Junqueira - Cofundador da Letrus</span>
              </div>

              ${
                viewModel.medalImage
                  ? `<div><img src="${escapeHtml(
                      viewModel.medalImage,
                    )}" alt="Medalha" class="medal-image" /></div>`
                  : ''
              }

              <div class="logos-block">
                <img src="${escapeHtml(
                  certificateAssets.letrusLogo,
                )}" alt="Letrus" class="letrus-logo" />
                <img src="${escapeHtml(
                  certificateAssets.olympicsLogo,
                )}" alt="Linguagem em Ação" class="olympics-logo" />
              </div>
            </footer>
          </div>
        </section>
      </div>
    </body>
  </html>`;
}
